import ResolutionVoteMW from "@/middlewares/ResolutionVote";

import MeetingORM from "@/store/orm-axios/models/Meeting";
import MandateORM from "@/store/orm-axios/models/Mandate";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";
import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";

var uuid = require("uuid");

import { meetingMinutesNames } from "@/constants/meeting.js";

import store from "@/store/store";

const DATE_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss.SSSZ";
const DATE_FORMAT = "YYYY-MM-DD";
const TIME_FORMAT = "HH:mm:ss.SSS";

export default {
  computed: {
    isMeetingStarted() {
      var meeting = MeetingORM.getters("getById")(this.$route.params.id);
      return !!meeting.minutes.find(minute => {
        return minute.event == meetingMinutesNames.meeting_start;
      });
    },
  },
  methods: {
    /** contact-arrived */
    async setContactArrivedEvent(contact_id, saveInDb = false) {
      try {
        var event = this.getContactArrivedEvent({ contact_id });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getContactArrivedEvent(eventInfo) {
      const { contact_id } = eventInfo;
      return {
        event: meetingMinutesNames.contact_arrived,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        contact_id,
        representant_type: "contact",
        representant_id: contact_id,
      };
    },
    /** contact-left */
    async setContactLeftEvent(contact_id, saveInDb = false) {
      try {
        var event = this.getContactLeftEvent({ contact_id });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getContactLeftEvent(eventInfo) {
      const { contact_id } = eventInfo;
      return {
        event: meetingMinutesNames.contact_left,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type: "contact",
        contact_id,
        representant_id: contact_id,
      };
    },

    /** participant-arrived */
    async setParticipantArrivedEvent(mandate_id, saveInDb = false) {
      try {
        const mandate = MandateORM.getters("getById")(mandate_id);

        var event = this.getParticipantArrivedEvent({ mandate });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getParticipantArrivedEvent(eventInfo) {
      const { mandate } = eventInfo;
      return {
        event: meetingMinutesNames.participant_arrived,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type: "owner",
        building_owner_id: mandate.building_owner_id,
        representant_id: mandate.building_owner_id,
        mandate_id: mandate.id,
        new_presence_status: mandate.presence_status,
      };
    },
    /** participant-left */
    async setParticipantLeftEvent(mandate_id, saveInDb = true) {
      try {
        const mandate = MandateORM.getters("getById")(mandate_id);

        var event = this.getParticipantLeftEvent({ mandate });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getParticipantLeftEvent(eventInfo) {
      const { mandate } = eventInfo;
      return {
        event: meetingMinutesNames.participant_left,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type: "owner",
        building_owner_id: mandate.building_owner_id,
        representant_id: mandate.building_owner_id,
        mandate_id: mandate.id,
        new_presence_status: this.mandatePresenceStatuses.not_present,
      };
    },

    /** mandate-added */
    async setMandateAddedEvent(mandate_id, saveInDb = false) {
      try {
        const mandate = MandateORM.getters("getById")(mandate_id);

        const { representant_type, representant_id } = this.getRepresentantInfoForEvent(mandate);

        var event = this.getMandateAddedEvent({
          mandate,
          representant_type,
          representant_id,
        });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getMandateAddedEvent(eventInfo) {
      const { mandate, representant_type, representant_id } = eventInfo;
      return {
        event: meetingMinutesNames.mandate_added,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type,
        building_owner_id: mandate.building_owner_id,
        representant_id,
        mandate_id: mandate.id,
        new_presence_status: mandate.presence_status,
      };
    },
    /** mandate-moved */
    async setMandateMovedEvent(mandate_id, moveInfo, saveInDb = false) {
      try {
        const {
          moveFromRepresentantType,
          moveFromRepresentantId,
          moveToRepresentantType,
          moveToRepresentantId,
        } = moveInfo;

        const mandate = MandateORM.getters("getById")(mandate_id);

        const { representant_type, representant_id } = this.getRepresentantInfoForEvent(mandate);

        var event = this.getMandateMovedEvent({
          mandate,
          representant_type,
          representant_id,
          moveFromRepresentantType,
          moveFromRepresentantId,
          moveToRepresentantType,
          moveToRepresentantId,
        });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getMandateMovedEvent(eventInfo) {
      const {
        mandate,
        representant_type,
        representant_id,
        moveFromRepresentantType,
        moveFromRepresentantId,
        moveToRepresentantType,
        moveToRepresentantId,
      } = eventInfo;
      return {
        event: meetingMinutesNames.mandate_moved,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type,
        building_owner_id: mandate.building_owner_id,
        representant_id,
        mandate_id: mandate.id,
        new_presence_status: mandate.presence_status,

        move_from_representant_type: moveFromRepresentantType,
        move_from_representant_id: moveFromRepresentantId,
        move_to_representant_type: moveToRepresentantType,
        move_to_representant_id: moveToRepresentantId,
      };
    },
    /** mandate-left */
    async setMandateLeftEvent(mandate_id, saveInDb = false) {
      try {
        const mandate = MandateORM.getters("getById")(mandate_id);

        const { representant_type, representant_id } = this.getRepresentantInfoForEvent(mandate);

        var event = this.getMandateLeftEvent({
          mandate,
          representant_type,
          representant_id,
        });
        this.saveEventsInStore([event]);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getMandateLeftEvent(eventInfo) {
      const { mandate, representant_type, representant_id } = eventInfo;
      return {
        event: meetingMinutesNames.mandate_left,
        uuid: this.getUuid(),
        date: this.getCustomDate(),

        representant_type,
        building_owner_id: mandate.building_owner_id,
        representant_id,
        mandate_id: mandate.id,
        new_presence_status: this.mandatePresenceStatuses.not_present,
      };
    },

    /** correspondence (+ invalid) */
    async setCorrespondenceEvents(saveInDb = false) {
      try {
        var correspondenceMandates = MandateORM.query()
          .where(m => {
            return (
              m.presence_status == this.mandatePresenceStatuses.correspondence ||
              m.presence_status == this.mandatePresenceStatuses.invalid_correspondence
            );
          })
          .get();
        if (correspondenceMandates.length == 0) return;

        for (const mandate of correspondenceMandates) {
          const isInvalid =
            mandate.presence_status == this.mandatePresenceStatuses.invalid_correspondence;
          await this.setCorrespondenceEvent(mandate.id, isInvalid);
        }

        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    async setCorrespondenceEvent(mandate_id, is_invalid = false, saveInDb = false) {
      try {
        const correspondenceEvent = this.findCorrespondenceEventIfExists(mandate_id);
        if (correspondenceEvent) this.removeEventFromStore(correspondenceEvent);

        const mandate = MandateORM.getters("getById")(mandate_id);

        var event = this.getCorrespondenceEvent({ mandate, is_invalid });
        this.saveEventsInStore([event], true);
        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getCorrespondenceEvent(eventInfo) {
      const { mandate, is_invalid } = eventInfo;

      return {
        event: meetingMinutesNames.correspondence,
        uuid: this.getUuid(),

        building_owner_id: mandate.building_owner_id,
        representant_type: "owner",
        representant_id: mandate.building_owner_id,
        mandate_id: mandate.id,
        new_presence_status: is_invalid
          ? this.mandatePresenceStatuses.invalid_correspondence
          : this.mandatePresenceStatuses.correspondence,
      };
    },
    async deleteCorrespondenceEvent(mandate_id, saveInDb = false) {
      try {
        const correspondenceEvent = this.findCorrespondenceEventIfExists(mandate_id);
        if (correspondenceEvent) {
          this.removeEventFromStore(correspondenceEvent);
          if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
        }
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    // ???: maybe better filter instead of find, in case there is a error and there are more
    findCorrespondenceEventIfExists(mandate_id) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const minutes = meeting.minutes;
      return this.$_.find(minutes, m => {
        return (
          (m.new_presence_status == this.mandatePresenceStatuses.correspondence ||
            m.new_presence_status == this.mandatePresenceStatuses.invalid_correspondence) &&
          m.mandate_id == mandate_id
        );
      });
    },

    /** general-details & meeting-start */
    async setGeneralDetailsAndMeetingStartEvents(saveInDb = false) {
      try {
        const generalDetailsEvent = this.getGeneralDetailsEvent();
        const meetingStartEvent = this.getMeetingStartEvent();
        this.saveEventsInStore([generalDetailsEvent, meetingStartEvent]);

        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getGeneralDetailsEvent() {
      return {
        event: meetingMinutesNames.general_details,
        uuid: this.getUuid(),

        /** !!!: votingLimitRules */
        totalTantiemesGenerales: this.votingLimitRules.totalTantiemesGenerales,

        votingLimitIsActive: this.votingLimitRules.votingLimitIsActive,
        votingLimitOperator: this.votingLimitRules.votingLimitOperator,
        votingIncludesMandate: this.votingLimitRules.votingIncludesMandate,
        votesLimitPerMandate: this.votingLimitRules.votesLimitPerMandate,
        tantiemesLimitPerMandate: this.votingLimitRules.tantiemesLimitPerMandate,

        plafonMajorityIsActive: this.votingLimitRules.plafonMajorityIsActive,
        plafonMajorityTantiemes: this.votingLimitRules.plafonMajorityTantiemes,
        totalTantiemesGeneralesPlafonMajority: this.votingLimitRules
          .totalTantiemesGeneralesPlafonMajority,
        plafonMajorityText: this.votingLimitRules.plafonMajorityText,

        article22IsActive: this.votingLimitRules.article22IsActive,
        buildingOwnerIdArticle22: this.votingLimitRules.buildingOwnerIdArticle22,
        reducedMandateTantiemesArticle22: this.votingLimitRules.reducedMandateTantiemesArticle22,
        totalTantiemesGeneralesArticle22: this.votingLimitRules.totalTantiemesGeneralesArticle22,
        /** ... */
      };
    },
    getMeetingStartEvent() {
      return {
        event: meetingMinutesNames.meeting_start,
        uuid: this.getUuid(),
        date: this.getNowUtc(),
      };
    },

    /** resolution-vote */
    async setResolutionVoteEvent(
      resolution_id,
      majority_id,
      saveInDb = false,
      updateVotedResolution = false,
      caseVoteCorrectionFirstMajority = false
    ) {
      let event = null;
      try {
        // ???: Don't understand why calling this function is necessary,
        //      before this, on Resolution.PUT, we get ResolutionVotes and also when we swich between Resolutions
        // await ResolutionVoteMW.FETCH(resolution_id);

        let votes = this.getVotesForCurrentResolution(resolution_id);

        let resolutionVote = null;
        if (caseVoteCorrectionFirstMajority) {
          this.updateVotesOnVotedResolutionInMinutes(resolution_id, majority_id, votes);
        } else {
          resolutionVote = this.ifResolutionWasVotedBeforeDeleteFromMinutes(resolution_id);

          if (updateVotedResolution && resolutionVote) {
            event = this.getResolutionVoteEvent({
              resolution_id,
              majority_id,
              votes,
              date: resolutionVote.date,
              uuid: resolutionVote.uuid,
            });
          } else {
            event = this.getResolutionVoteEvent({
              resolution_id,
              majority_id,
              votes,
            });
          }

          this.saveEventsInStore([event]);
        }

        // NOTE: Update only the minutes without getting the minutes response back, calling general update will reduce performance
        if (saveInDb) await this.updateMeetingMinutesInDb(this.$route.params.id);
      } catch (err) {
        console.log(err);
        // NOTE: Remove event from local store, and send error to admin
        this.removeEventFromStore(event);
        store.dispatch("adminNotification/sendErrorToAdmin", {
          message: `An error occured when updating votes on meeting->minutes on meetingResolutionId: ${resolution_id}`,
          jsonData: JSON.stringify(err.response.data),
        });
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getResolutionVoteEvent(eventInfo) {
      const { resolution_id, majority_id, votes, date, uuid, revote_majority_id } = eventInfo;

      var resolution = MeetingResolutionORM.getters("getById")(resolution_id);

      return {
        event: meetingMinutesNames.resolution_vote,
        uuid: uuid ? uuid : this.getUuid(),
        date: date ? date : this.getCustomDate(),

        resolution_id,
        majority_id,
        votes,
        revote_majority_id,

        parent_resolution_id: resolution.parent_resolution_id,
      };
    },
    ifResolutionWasVotedBeforeDeleteFromMinutes(resolutionId) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const minutes = meeting.minutes;
      const votedResolution = this.$_.find(minutes, m => {
        // NOTE: keep events if with revote_majority_id ..
        return (
          m.event == meetingMinutesNames.resolution_vote &&
          m.resolution_id == resolutionId &&
          !m.revote_majority_id
        );
      });

      if (votedResolution) {
        this.removeEventFromStore(votedResolution);
      }
      return votedResolution;
    },
    updateVotesOnVotedResolutionInMinutes(resolutionId, majorityId, votes) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const minutes = meeting.minutes;

      minutes.forEach(minute => {
        if (
          minute.event == meetingMinutesNames.resolution_vote &&
          minute.resolution_id == resolutionId &&
          minute.majority_id == majorityId
        ) {
          minute.votes = votes;
        }
      });
    },
    getVotesForCurrentResolution(resolutionId) {
      var currentResolution = MeetingResolutionORM.query()
        .where("id", resolutionId)
        .with("resolution_votes", query => {
          query
            .where(rv => {
              // !!!: ignored_correspondence
              return !rv.ignored_correspondence;
            })
            .with("mandate");
        })
        .first();

      var votes = null;
      if (
        currentResolution.status != this.meetingResolutionStatuses.not_resolved &&
        currentResolution.status != this.meetingResolutionStatuses.sans_vote
      ) {
        votes = this.getResolutionVotesForMinutes(currentResolution);
      }
      return votes;
    },
    getResolutionVotesForMinutes(resolution) {
      var votes = [];
      var votesFor = [];
      var votesAgainst = [];
      var votesAbstain = [];
      var votesNsp = [];

      for (let resolution_vote of resolution.resolution_votes) {
        // Check for invalid_correspondence presence status, and don't save the votes
        if (
          resolution_vote.mandate &&
          resolution_vote.mandate.presence_status !=
            this.mandatePresenceStatuses.invalid_correspondence
        ) {
          var newVote = this.createVote(resolution, resolution_vote);
          votes.push(newVote);
        }
      }

      for (let vote of votes) {
        if (vote.vote == "for") {
          votesFor.push(vote);
        }
        if (vote.vote == "against") {
          votesAgainst.push(vote);
        }
        if (vote.vote == "abstain") {
          votesAbstain.push(vote);
        }
        if (vote.vote == "nsp") {
          votesNsp.push(vote);
        }
      }

      return { votesFor, votesAgainst, votesAbstain, votesNsp };
    },
    createVote(resolution, resolution_vote) {
      resolution_vote = ResolutionVoteORM.query()
        .where("id", resolution_vote.id)
        .with("mandate")
        .first();

      let tantiemes = this.getUsedMandateTantiemesByVotingCategory(
        resolution_vote.mandate.id,
        resolution.voting_category_id
      );

      return this.getVote(resolution_vote, tantiemes);
    },
    getVote(resolution_vote, tantiemes) {
      return {
        building_owner_id: resolution_vote.mandate.building_owner_id,
        tantiemes,
        vote: Object.keys(this.voteTypes).find(key => this.voteTypes[key] == resolution_vote.vote),
      };
    },
    // NOTE: This function sets the revote_majority_id in the event, for the revoted resolution (not for child)
    setRevoteMajorityIdForResolutionVote(currentResolutionId) {
      var meeting = MeetingORM.getters("getById")(this.$route.params.id);
      var resolution = MeetingResolutionORM.find(currentResolutionId);
      for (let i = meeting.minutes.length - 1; i >= 0; i--) {
        if (
          meeting.minutes[i].event == meetingMinutesNames.resolution_vote &&
          meeting.minutes[i].resolution_id == currentResolutionId
        ) {
          meeting.minutes[i].revote_majority_id = resolution.revote_majority_id;
          break;
        }
      }

      // update minutes in ORM
      MeetingORM.update({
        where: meeting.id,
        data: {
          minutes: meeting.minutes,
        },
      });

      this.saveMeetingInDb(this.$route.params.id);
    },

    // !!!: update resolution votes events if delete correspondence after meeting started
    async updateResolutionVoteEventsAfterDeleteCorrespondence(building_owner_id, saveInDb = false) {
      try {
        const meeting = MeetingORM.getters("getById")(this.$route.params.id);
        let minutes = meeting.minutes;

        minutes.forEach(minute => {
          if (
            minute.event == meetingMinutesNames.resolution_vote &&
            minute.votes &&
            JSON.stringify(minute.votes).indexOf(building_owner_id) > -1
          ) {
            for (const [votesByTypeKey, votesByTypeArray] of Object.entries(minute.votes)) {
              const voteToDeleteIndex = this.$_.findIndex(votesByTypeArray, {
                building_owner_id: building_owner_id,
              });
              if (voteToDeleteIndex > -1) {
                minute.votes[votesByTypeKey].splice(voteToDeleteIndex, 1);
                break;
              }
            }
          }
        });

        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },

    /** meeting-end */
    async setMeetingEndEvent(saveInDb = false) {
      try {
        let existentMeetingEndEvent = this.hasMeetingEndEvent();
        if (existentMeetingEndEvent) {
          this.removeEventFromStore(existentMeetingEndEvent);
        }
        const event = this.getMeetingEndEvent();
        this.saveEventsInStore([event]);

        if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },
    getMeetingEndEvent() {
      return {
        event: meetingMinutesNames.meeting_end,
        uuid: this.getUuid(),
        date: this.getCustomDate(),
      };
    },

    async removeMinuteEvent(event, saveInDb = false) {
      const questionResult = await this.$swal(this.alertQuestion());
      if (!questionResult.value) return;

      this.removeEventFromStore(event);
      if (saveInDb) await this.saveMeetingInDb(this.$route.params.id);
    },

    /** NOTE: helper functions: start */
    saveEventsInStore(events, addAtBeginning = false) {
      MeetingORM.update({
        where: this.$route.params.id,
        data(item) {
          events.forEach(event => {
            if (addAtBeginning) item.minutes.unshift(event);
            else item.minutes.push(event);
          });
        },
      });
    },
    removeEventFromStore(event) {
      var self = this;
      MeetingORM.update({
        where: self.$route.params.id,
        data(item) {
          let eventIndex = self.$_.findIndex(item.minutes, {
            uuid: event.uuid,
          });
          if (eventIndex != -1) {
            item.minutes.splice(eventIndex, 1);
          }
        },
      });
    },
    getUuid() {
      return uuid.v4();
    },
    getNowUtc() {
      return this.$moment.utc().format(DATE_TIME_FORMAT);
    },
    getRepresentantInfoForEvent(mandate) {
      var representant_type = "owner";
      var representant_id = mandate.representant_owner_id;
      if (mandate.representant_contact_id) {
        representant_type = "contact";
        representant_id = mandate.representant_contact_id;
      }
      return { representant_type, representant_id };
    },

    async changeMinuteEventDate(datePickerEvent, minuteEvent) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const indexOfEventToChange = this.$_.findIndex(meeting.minutes, minute => {
        return minute.uuid == minuteEvent.uuid;
      });
      const self = this;
      MeetingORM.update({
        where: this.$route.params.id,
        data(item) {
          const formatedDateToSet = self.getCustomDate(datePickerEvent);
          item.minutes[indexOfEventToChange].date = formatedDateToSet;

          // !!!: sort minute events by date ascending
          item.minutes = self.$_.sortBy(item.minutes, minute => (minute.date ? minute.date : ""));
        },
      });

      await this.saveMeetingInDb(this.$route.params.id);
    },

    async createResolutionMajorChangeEvent(meetingId) {
      let resolutionMajorChange = null;
      let parsedVotes = [];
      let meeting = MeetingORM.find(meetingId);
      const indexOfResolutionMajorChange = this.$_.findIndex(meeting.minutes, item => {
        return (
          item.event == meetingMinutesNames.resolution_major_change &&
          item.resolution_id == this.currentResolutionId
        );
      });
      let votes = ResolutionVoteORM.query()
        .where(vote => {
          return (
            vote.meeting_has_resolution_id == this.currentResolutionId &&
            vote.presence_status == this.mandatePresenceStatuses.correspondence &&
            vote.vote == this.voteTypes.nsp
          );
        })
        .get();
      votes.forEach(vote => {
        const newVote = this.createVote(this.currentResolution, vote);
        parsedVotes.push(newVote);
      });
      if (indexOfResolutionMajorChange != -1) {
        // Update resolution_major_change event
        meeting.minutes[indexOfResolutionMajorChange].votes = parsedVotes;
        MeetingORM.update({
          where: meeting.id,
          data: {
            minutes: meeting.minutes,
          },
        });
      } else {
        // Create new resolution_major_change event
        resolutionMajorChange = {
          event: meetingMinutesNames.resolution_major_change,
          resolution_id: this.currentResolutionId,
          votes: parsedVotes,
        };
        MeetingORM.update({
          where: meeting.id,
          data(item) {
            item.minutes.push(resolutionMajorChange);
          },
        });
      }
      await this.saveMeetingInDb(this.$route.params.id);
    },

    /** helper functions: end */

    // !!!: added a new property in meeting minutes objects: uuid.. this function is used so that the old meetings that don't have it set yet, would be updated
    async CHECK_IF_MINUTES_HAVE_UUIDS_SET(meeting) {
      try {
        var atLeastOneUpdated = false;
        meeting.minutes.forEach(minute => {
          if (!("uuid" in minute)) {
            atLeastOneUpdated = true;
            minute.uuid = this.getUuid();
          }
        });

        if (atLeastOneUpdated) {
          MeetingORM.update(meeting);
          await this.saveMeetingInDb(meeting.id, meeting);
        }
      } catch (err) {
        this.$swal(this.alertError());
        throw new Error(err);
      }
    },

    getMeetingStartEventDate() {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const meetingStartEvent = this.$_.find(meeting.minutes, m => {
        return m.event == meetingMinutesNames.meeting_start;
      });
      if (meetingStartEvent) {
        return meetingStartEvent.date;
      } else {
        // HACK: DEV-4126 : If meetingStartEvent doesn't exist (event is before meeting start), date will be nowUtc
        return this.getNowUtc();
      }
    },
    // HACK: DEV-4126 : Every event from minutes after meeting start will have meetingStart date and hour from date now
    getCustomDate(date) {
      let processedTime = "";
      if (date) {
        processedTime = this.$moment(date).format(TIME_FORMAT);
      } else {
        processedTime = this.$moment().format(TIME_FORMAT);
      }
      let meetingStartEventDateTime = this.getMeetingStartEventDate();
      let meetingStartEventDate = this.$moment(meetingStartEventDateTime).format(DATE_FORMAT);

      return this.$moment(meetingStartEventDate + " " + processedTime)
        .utc()
        .format(DATE_TIME_FORMAT);
    },
    getMeetingEndEventDate() {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const meetingEndEvent = this.$_.find(meeting.minutes, m => {
        return m.event == meetingMinutesNames.meeting_end;
      });
      if (meetingEndEvent) {
        return meetingEndEvent.date;
      } else {
        return null;
      }
    },
    isEventEndDateBeforeStartDate() {
      let eventStartDate = this.getMeetingStartEventDate();
      let eventEndDate = this.getMeetingEndEventDate();

      if (eventStartDate && eventEndDate) {
        return this.$moment(eventEndDate).isBefore(eventStartDate);
      }
    },
    areResolutionVoteEventsInOrder() {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      let minutes = meeting.minutes;
      let toReturn = true;

      const resolutionVoteEvents = this.$_.filter(minutes, minute => {
        return minute.event == meetingMinutesNames.resolution_vote;
      });

      resolutionVoteEvents.forEach(minuteI => {
        var resolutionI = MeetingResolutionORM.getters("getById")(minuteI.resolution_id);
        resolutionVoteEvents.forEach(minuteJ => {
          var resolutionJ = MeetingResolutionORM.getters("getById")(minuteJ.resolution_id);
          if (
            ((!minuteI.parent_resolution_id && !minuteJ.parent_resolution_id) ||
              minuteI.parent_resolution_id == minuteJ.parent_resolution_id) &&
            minuteI.date < minuteJ.date &&
            resolutionI.position > resolutionJ.position
          ) {
            toReturn = false;
          }
        });
      });
      return toReturn;
    },
    hasMeetingEndEvent() {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const meetingEndEvent = this.$_.find(meeting.minutes, m => {
        return m.event == meetingMinutesNames.meeting_end;
      });
      if (meetingEndEvent) {
        return meetingEndEvent;
      }
      return null;
    },
    getCorrespondenceEvents() {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const minutes = meeting.minutes;
      return minutes.filter(m => {
        return (
          m.new_presence_status == this.mandatePresenceStatuses.correspondence ||
          m.new_presence_status == this.mandatePresenceStatuses.invalid_correspondence
        );
      });
    },
    getMinutesMandatesForResolution(resolutionId) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const resolutionMinuteEvent = meeting.minutes.find(
        item =>
          item.event == meetingMinutesNames.resolution_vote && item.resolution_id == resolutionId
      );

      if (!resolutionMinuteEvent) return [];

      return meeting.minutes.filter(
        event =>
          (event.mandate_id && event.event === meetingMinutesNames.correspondence) ||
          (event.mandate_id && event.date && event.date < resolutionMinuteEvent.date)
      );
    },
    getMandateLastUpdateFromMinutes(minutesEvents, mandate_id) {
      let mandateEvents = minutesEvents.filter(event => event.mandate_id == mandate_id);

      if (mandateEvents.length == 0) return null;

      let mandateEventsWithDate = mandateEvents.filter(event => event.date);
      const mandateEventsNoDate = mandateEvents.filter(event => !event.date);

      // NOTE: Descending order
      mandateEventsWithDate = mandateEventsWithDate.sort((a, b) => b.date - a.date);

      // NOTE: Merge first array with dates that is sorted with the unsorted array with no dates (this case is especially for correspondence events)
      mandateEvents = mandateEventsWithDate.concat(mandateEventsNoDate);

      return mandateEvents[0];
    },
    hasMinutesRegisteredChangesOnMandatesAfterCurrentResolution(resolutionId) {
      const meeting = MeetingORM.getters("getById")(this.$route.params.id);
      const resolutionMinuteEvent = meeting.minutes.find(
        item =>
          item.event == meetingMinutesNames.resolution_vote && item.resolution_id == resolutionId
      );

      if (!resolutionMinuteEvent) return false;

      const events = meeting.minutes.filter(
        event => event.mandate_id && event.date && event.date > resolutionMinuteEvent.date
      );

      if (events.length > 0) {
        return true;
      }

      return false;
    },
    updateResolutionVotesFromMinutes(resolutionId, majorityId) {
      const resolutionVoteEvents = this.meeting.minutes.filter(
        event =>
          event.event === meetingMinutesNames.resolution_vote &&
          event.resolution_id === resolutionId &&
          event.majority_id === majorityId
      );

      if (resolutionVoteEvents.length == 1) {
        const resolutionVoteEvent = resolutionVoteEvents[0];
        const votes = resolutionVoteEvent.votes;
        if (votes.votesAbstain.length > 0) {
          for (const vote of votes.votesAbstain) {
            this.findAndUpdateResolutionVote(vote.building_owner_id, this.voteTypes.abstain);
          }
        }
        if (votes.votesAgainst.length > 0) {
          for (const vote of votes.votesAgainst) {
            this.findAndUpdateResolutionVote(vote.building_owner_id, this.voteTypes.against);
          }
        }
        if (votes.votesFor.length > 0) {
          for (const vote of votes.votesFor) {
            this.findAndUpdateResolutionVote(vote.building_owner_id, this.voteTypes.for);
          }
        }
        if (votes.votesNsp.length > 0) {
          for (const vote of votes.votesNsp) {
            this.findAndUpdateResolutionVote(vote.building_owner_id, this.voteTypes.nsp);
          }
        }
      }
    },
    findAndUpdateResolutionVote(building_owner_id, vote) {
      const mandate = MandateORM.query()
        .where("building_owner_id", building_owner_id)
        .with("resolution_votes")
        .first();
      const resolutionVotes = mandate.resolution_votes;
      for (const resolutionVote of resolutionVotes) {
        ResolutionVoteORM.update({
          where: resolutionVote.id,
          data: { vote: vote },
        });
      }
    },
  },
};
